export default __webpack_public_path__ + "static/media/halal.495b266e.svg";